import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { FaFileExcel, FaFileCsv, FaDownload, FaFilter } from "react-icons/fa";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import "./Partner.css";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function PartnerPayout_History({ partnerId }) {
    const { fetchRequest } = useMyContext();
    const BaseUrl = process.env.REACT_APP_Baseurl;
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedPeriod, setSelectedPeriod] = useState("All Periods");
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalResults, setTotalResults] = useState(0);

    const role = localStorage.getItem('role');
    const userId = localStorage.getItem('user_id');
    const effectivePartnerId = partnerId || (role === "4" ? userId : undefined);

    useEffect(() => {
        fetchHistory();
    }, [effectivePartnerId, selectedPeriod, currentPage]);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: "GET",
                url: `${BaseUrl}/admin/partner/payout-history`,
                params: {
                    partner_id: effectivePartnerId,
                    period: selectedPeriod !== "All Periods" ? selectedPeriod : undefined,
                    page: currentPage,
                    limit: itemsPerPage
                }
            });
            if (response?.status) {
                setInvoices(response.data || []);
                setTotalResults(response.total || 0);
            }
        } catch (error) {
            console.error("Error fetching payout history:", error);
        } finally {
            setLoading(false);
        }
    };

    const totalPages = Math.ceil(totalResults / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handlePeriodChange = (event) => {
        setSelectedPeriod(event.target.value);
        setCurrentPage(1);
    };

    const handleDownloadPDF = async (invoice) => {
        const { jsPDF } = await import("jspdf");
        await import("jspdf-autotable");
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.text("Partner Payout Details", 14, 15);

        const tableColumn = ["Field", "Details"];
        const tableRows = [
            ["Partner Name", invoice.partner_name],
            ["Period", invoice.period],
            ["Total Revenue", invoice.total_revenue],
            ["Commission", invoice.commission],
            ["Net Payout", invoice.net_payout],
            ["Payment Date", invoice.payment_date],
            ["Payment Details", invoice.payment_method],
        ];

        doc.autoTable({
            startY: 25,
            head: [tableColumn],
            body: tableRows,
        });

        doc.save(`${invoice.partner_name}_Payout.pdf`);
    };

    const handleDownloadCSV = () => {
        if (!invoices.length) return;
        const headers = "Partner,Period,Total Revenue,Commission,Net Payout,Payment Date,Payment Details\n";
        const rows = invoices.map(invoice =>
            `${invoice.partner_name},${invoice.period},${invoice.total_revenue},${invoice.commission},${invoice.net_payout},${invoice.payment_date},${invoice.payment_method}`
        ).join("\n");

        const csvContent = "data:text/csv;charset=utf-8," + headers + rows;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "partner_payout_history.csv");
        document.body.appendChild(link);
        link.click();
    };

    const handleDownloadExcel = async () => {
        if (!invoices.length) return;
        const XLSX = await import("xlsx");
        const ws = XLSX.utils.json_to_sheet(invoices);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Partner Payouts");
        XLSX.writeFile(wb, "partner_payout_history.xlsx");
    };

    return (
        <div className="container mx-auto p-6">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h4 className="mb-0">Monthly Invoices</h4>
                <div className="d-flex gap-2 text-end">
                    <Button variant="outline-secondary" onClick={handleDownloadExcel} disabled={!invoices.length}>
                        <FaFileExcel /> Export to Excel
                    </Button>
                    <Button variant="outline-secondary" onClick={handleDownloadCSV} disabled={!invoices.length}>
                        <FaFileCsv /> Export to CSV
                    </Button>
                </div>
            </div>
            <div className="invoicefilter py-2">
                <div className="invoice-filter-container d-flex justify-content-between align-items-center">
                    <input type="text" placeholder="Search by partner name" className="form-control search-input" />
                    <div className="d-flex align-items-center gap-2 filter-group">
                        <select className="form-select period-select" onChange={handlePeriodChange} value={selectedPeriod}>
                            <option>All Periods</option>
                            <option>Feb 2025</option>
                            <option>Mar 2025</option>
                        </select>
                        <Button variant="primary" className="filter-btn">
                            <FaFilter /> Filter
                        </Button>
                    </div>
                </div>
            </div>
            <div className="transactions">
                <div className="table-responsive">
                    <table className="table invoice-table">
                        <thead className="table-light">
                            <tr>
                                <th>Partner Name</th>
                                <th>Period Covered</th>
                                <th>Total Revenue</th>
                                <th>Commission</th>
                                <th>Net Payout</th>
                                <th>Payment Details</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.length > 0 ? (
                                invoices.map((invoice, index) => (
                                    <tr key={index}>
                                        <td>{invoice.partner_name}</td>
                                        <td>{invoice.period}</td>
                                        <td className="text-end">{invoice.total_revenue}</td>
                                        <td className="text-end text-danger">{invoice.commission}</td>
                                        <td className="text-end text-success">{invoice.net_payout}</td>
                                        <td>
                                            {invoice.payment_date} <br />
                                            <span className="text-muted">{invoice.payment_method}</span>
                                        </td>
                                        <td className="text-center">
                                            <Button variant="text" className="text-primary" onClick={() => handleDownloadPDF(invoice)}>
                                                <FaDownload /> PDF
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="7" className="text-center p-4">No history records found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination-container d-flex justify-content-between align-items-center p-3">
                    <span>
                        Showing {Math.min(currentPage * itemsPerPage, totalResults)} of {totalResults} results
                    </span>
                    <div className="btn-group">
                        <Button variant="outline-secondary" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>&lt;</Button>
                        {[...Array(totalPages)].map((_, i) => (
                            <Button key={i} variant={currentPage === i + 1 ? "primary" : "outline-secondary"} onClick={() => handlePageChange(i + 1)}>{i + 1}</Button>
                        ))}
                        <Button variant="outline-secondary" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>&gt;</Button>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default PartnerPayout_History;
